<template>
  <div class="content">
    <div v-html="news_content"></div>
  </div>
</template>
<script>
import { group_sign, getCookie } from '../../utils/tool';
export default {
  data() {
    return {
      news_content: "",
      account_id:Number(getCookie('account_id')),
    };
  },
  methods: {
    getRichContent() {
      let that = this;
      var param = group_sign({account_id: that.account_id,type: 2})
      this.$axios.post(this.$Api.apiGetUserAgreement,param).then(
        res => {
          if (res.data.errcode == 0) {
            that.news_content = that.htmlDecode(res.data.result.content);
          } else {
            that.news_content = res.data.errmsg;
          }
        }
      ).catch(error => {});
    },
    htmlDecode(str) {
      var s = "";
      if (str.length === 0) return "暂无详情";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&#39;/g, '"');
      s = s.replace(/&quot;/g, '"');
      return s;
    }
  },
  beforeMount() {
    this.getRichContent();
  }
};
</script>
<style lang="less" scoped>
.content {
  margin: 0 auto;
  margin-top: 20px;
  width: 1180px;
  padding: 33px;
  background: #ffffff;
  min-height: 500px;
}
</style>
